/* 布局 */
//前台
import Layout from "@views/layout";

const templatemanageactivityRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "templatemanageactivity",
            name: "TEMPLATEMANAGEACTIVITY",
            meta: {
                title: "话题模板",
                sort: 1,
            },
            component: () => import("@views/business/templatemanageactivity/index.vue"),
            redirect: {
                name: "TEMPLATEMANAGEACTIVITY_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TEMPLATEMANAGEACTIVITY_LIST",
                    meta: {
                        title: "话题模板",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/templatemanageactivity/list.vue"),
                },
                {
                    path: "add",
                    name: "TEMPLATEMANAGEACTIVITY_ADD",
                    meta: {
                        title: "新增模板管理-话题模板（其实是活动名称）",
                        parentPath: '/business/templatemanageactivity/list',
                        operate: true,
                    },
                    component: () => import("@views/business/templatemanageactivity/form.vue"),
                },
                {
                    path: "edit",
                    name: "TEMPLATEMANAGEACTIVITY_EDIT",
                    meta: {
                        title: "编辑模板管理-话题模板（其实是活动名称）",
                        parentPath: '/business/templatemanageactivity/list',
                        operate: true,
                    },
                    component: () => import("@views/business/templatemanageactivity/form.vue"),
                },
            ],
        },


    ],
};

export default templatemanageactivityRouter;
